import type { Dependent } from './dependent.type.ts';
export interface DependentExtension extends Dependent {}
export class DependentExtension {
  // ── Computed Properties ──
  get enrolledDate() {
    const activeLogin = this.person?.user?.logins?.find((l) => l.isActive);
    return activeLogin?.createdAt;
  }

  get fullName() {
    return [this.firstName, this.lastName].join(' ');
  }

  get notDeleted() {
    return this.deletedAt === null;
  }

  /** Relationship name without its enum flavor: `CHILD` from `DependentRelationship.CHILD`. */
  get relationshipName() {
    return this.relationship?.split('.').pop() ?? '';
  }

  /**
   * False for family-invite-only relationships, stored as `FamilyRelationship.*` (e.g. a parent),
   * which Tuition Assistance never offers.
   */
  get isTuitionAssistanceRelationship() {
    return this.relationship?.startsWith('DependentRelationship.') ?? false;
  }
}

const Registration = {
  kind: 'object',
  name: 'dependent',
  features: DependentExtension,
};
export default Registration;
